/**
 * Ponte tema -> Maxfem Cart Drawer (app embed <mx-cart-drawer>, window.MxCart).
 *
 * Substitui a ponte do Section Store. O app ja intercepta sozinho os submits de
 * form[action*="/cart/add"], os links para /cart e o parametro ?cart_show, entao
 * aqui so fica a compatibilidade com codigo antigo do tema que chama
 * window.SectionStoreCart.open()/refresh().
 */
(function () {
  if (window.quick_cart && window.quick_cart.show) return;
  if (window.SectionStoreCart) return;
  function api() { return window.MxCart; }
  window.SectionStoreCart = {
    open: function () { var a = api(); if (a) a.open(); else document.addEventListener('mx-cart:ready', function () { window.MxCart.open(); }, { once: true }); },
    close: function () { var a = api(); if (a) a.close(); },
    refresh: function () { var a = api(); return a ? a.refresh() : Promise.resolve(); }
  };
})();

(function () {
  if (document.getElementById('mx-cart-scroll-guard')) return;
  var root = document.documentElement;
  var style = document.createElement('style');
  style.id = 'mx-cart-scroll-guard';
  style.textContent = 'html.mx-cart-open{overflow:hidden!important;overscroll-behavior:none}html.mx-cart-open>body{overscroll-behavior:none}';
  document.head.appendChild(style);
  var touch = null;

  document.addEventListener('touchstart', function (event) {
    touch = root.classList.contains('mx-cart-open') && event.touches.length === 1
      ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
      : null;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    if (!touch || !root.classList.contains('mx-cart-open') || event.touches.length !== 1) return;
    var point = event.touches[0];
    var dx = point.clientX - touch.x;
    var dy = point.clientY - touch.y;
    touch = { x: point.clientX, y: point.clientY };
    if (!dy || Math.abs(dx) > Math.abs(dy)) return;
    var path = event.composedPath();
    var inCart = path.some(function (node) {
      return node instanceof Element && node.matches('mx-cart-drawer[data-open]');
    });
    var canScroll = inCart && path.some(function (node) {
      if (!(node instanceof Element) || node === document.body || node === root) return false;
      var overflow = getComputedStyle(node).overflowY;
      if (overflow !== 'auto' && overflow !== 'scroll') return false;
      var max = node.scrollHeight - node.clientHeight;
      return max > 1 && (dy > 0 ? node.scrollTop > 0 : node.scrollTop < max - 1);
    });
    if (!canScroll && event.cancelable) event.preventDefault();
  }, { passive: false, capture: true });

  document.addEventListener('touchend', function () { touch = null; }, { passive: true, capture: true });
  document.addEventListener('touchcancel', function () { touch = null; }, { passive: true, capture: true });
})();
